var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-run-container width-100 height-100",class:{ 'is-active': _vm.isActive }},[_c('FlowRun',_vm._g({attrs:{"inAppMode":"","hashId":_vm.hashId}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }